/**!
 * Created by Leonardo Cheslacki on 13/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import GamesController from './GamesController';

import WithType from './../helpers/WithType';

import config from './../../../../config';

const {default: {routes: {api, web}}} = config;

let _this = {};

/**
 *
 */
class GamesIsland extends GamesController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            element: null
        };

        _this = this;
    };

    setMenuActivityLevels = () => {
        const
            _this_frame = this.getFrame(),
            {occ_title} = _this_frame,
            {data} = this.state,
            quiz = this.verifyField(data, 'quiz'),
            array = this.verifyField(quiz, 'children');

        occ_title.text = this.verifyField(quiz, 'title');

        for (let i = 0; i < array.length; i++) {
            let
                occurrence = this.padWithLeadingZeros((i + 1), 2),
                item = array[i],
                {id, title} = item,
                uri = `${web.uri_activity_level}/${id}`;

            _this_frame[`occ_title_${occurrence}`].text = title;
            //this.addImage(_this_frame[`occ_menu_${occurrence}`], item);
            this.setAction({uri: uri, occ: `menu_${occurrence}A`});
            this.setAction({uri: uri, occ: `menu_${occurrence}B`});
        }
    }

    setMenuActivity = () => {
        const
            _this_frame = this.getFrame(),
            {data} = this.state,
            array = this.verifyField(data, 'classroom_student.year.quizzes_activities');

        for (let i = 0; i < array.length; i++) {
            let
                occurrence = this.padWithLeadingZeros((i + 1), 2),
                item = array[i],
                {id, title} = item,
                uri = `${web.uri_activity_levels}/${id}`;

            _this_frame[`occ_title_${occurrence}`].text = title;
            this.addImage(_this_frame[`occ_menu_${occurrence}`], item);
            this.setAction({uri: uri, occ: `menu_${occurrence}A`});
            this.setAction({uri: uri, occ: `menu_${occurrence}B`});
        }
    }

    startActivity = () => {
        const {button_menu_activity} = this.props;

        this.setNavbar();

        this.setMenuActivity();

        this.setActions(button_menu_activity);
    };

    startActivityLevels = () => {
        const {button_menu_activity_levels} = this.props;

        this.setNavbar();

        this.setMenuActivityLevels();

        this.setActions(button_menu_activity_levels);
    };

    startGame = () => {
        const {button_menu_game} = this.props;

        this.setNavbar();

        this.setActions(button_menu_game);
    };

    initActivityLevels = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_activity_levels}/${this.getIdUri()}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startActivityLevels);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initActivity = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_activity}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startActivity);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };

    initGame = () => {
        this.gotoAndStopFrame(this.get(), 1);

        this.main.getForm(`${this.$root_uri}/${api.api_profile}`, {}, {
            done: ({status, errors, data}) => {
                if (Boolean(status)) {
                    this.setState({...this.state, data: data}, this.startGame);
                } else {
                    console.log(errors);
                }
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.emit('process_end', {});
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
GamesIsland.propTypes = {
    current_name: PropTypes.string,
    button_navbar: PropTypes.array,
    button_menu_game: PropTypes.array,
    button_menu_activity: PropTypes.array,
    button_menu_activity_levels: PropTypes.array
};

/**
 *
 * @type {{}}
 */
GamesIsland.defaultProps = {
    current_name: null,
    button_navbar: [
        {
            occ: 'profile',
            uri: web.uri_profile
        },
        {
            occ: 'dashboard',
            uri: web.uri_dashboard
        },
        {
            occ: 'logout',
            uri: web.uri_logout
        }
    ],
    button_menu_game: [
        {
            occ: 'back',
            uri: web.uri_dashboard
        },
        {
            occ: 'menu_01A',
            uri: web.uri_activity
        },
        {
            occ: 'menu_02A',
            uri: web.uri_digital
        }
    ],
    button_menu_activity: [
        {
            occ: 'back',
            uri: web.uri_game
        }
    ],
    button_menu_activity_levels: [
        {
            occ: 'back',
            uri:  web.uri_activity
        }
    ]
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(GamesIsland, {className: 'GamesIsland'});
